<template>
  <div class="outline" v-for="item in videoData[0]?.advice" :key="item.advID">
    <ul>
      <li>
        <a href="javascript:;" @click="showAdvice(item.advID)">{{
          item.advName
        }}</a
        ><i
          @click="showAdvice(item.advID)"
          style="font-size: 25px"
          class="iconfont icon-youjiantou"
        ></i>
      </li>
    </ul>
  </div>
  <div class="dialog">
    <el-dialog v-model="visible" align-center width="750">
      <div v-for="item in advice" :key="item.lineID" class="header">
        <h3>{{ item.advName }}</h3>
        <p>作者/来源：{{ item.advAuthor }}</p>
        <p v-html="item.advBody"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from "vue";
import { findAdviceView } from "@/api/video";
export default {
  props: {
    videoData: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const visible = ref(false);
    const advice = ref([]);
    const showAdvice = (advID) => {
      visible.value = true;
      findAdviceView(advID)
        .then((data) => {
          advice.value = data;
        })
        .catch((error) => {
          console.log(error);
        });
    };
    return { showAdvice, visible, advice };
  },
};
</script>

<style lang="less" scoped>
.outline {
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      display: flex;
      align-items: center;

      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      & :hover {
        cursor: pointer;
        color: @shColor;
      }
      i {
        line-height: 50px;
      }
      //background: #dedede;
    }
  }
}
.dialog {
  p {
    margin-top: 15px;
  }
}
</style>
